






import { Component, Vue } from "vue-property-decorator";
import CriticalLabResultList from "@/components/critical-lab-result/CriticalLabResultList.vue";

@Component({
  components: { CriticalLabResultList }
})
export default class CriticalLabResultReportingPage extends Vue {}
